export function selectAllInTextInput(e: React.FocusEvent) {
    if (!(e.target instanceof HTMLInputElement)) return;

    if (e.target.select !== undefined) {
        e.target.select();
    } else {
        e.target.setSelectionRange(0, e.target.value.length);
    }
}
